import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import NewsletterPopup from "./NewsletterPopup";
import { CheckCircle } from "lucide-react";

class NewLanding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedButton: "projectPlanning",
      showNewsletterPopup: true,
      isMobile: window.innerWidth < 768,
    };
    this.targetRef = React.createRef();
  }

  scrollToTarget = () => {
    this.targetRef.current.scrollIntoView({ behavior: "smooth" });
  };

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  selectButton = (buttonName) => {
    this.setState({ selectedButton: buttonName });
  };

  closeNewsletterPopup = () => {
    this.setState({ showNewsletterPopup: false });
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({
      isMobile: window.innerWidth < 768,
    });
  };

  // componentDidMount() {
  //     console.log("push")
  //     this.props.history.push("/about-us");
  //     this.props.history.push("/");
  // }

  render() {
    const { selectedButton } = this.state;
    return (
      <>
        {/* {this.state.showNewsletterPopup && (
          <NewsletterPopup onClose={this.closeNewsletterPopup} />
        )} */}
        <Navbar
          scrollToTop={this.scrollToTop}
          scrollToTarget={this.scrollToTarget}
        />
        <div className="nl-main-container">
          <div
            className="nl-section intro"
            style={{
              marginTop: "50px",
              marginBottom: "60px",
              background: "#f8fafc",
            }}
          >
            <div
              className="nl-content intro"
              style={{ maxWidth: "1200px", margin: "0 auto" }}
            >
              <div
                className="nl-content-half intro-left fade-in"
                style={{ maxWidth: "700px" }}
              >
                <h1
                  style={{
                    fontSize: "42px",
                    fontWeight: "700",
                    lineHeight: "1.2",
                    marginBottom: "20px",
                    paddingTop: this.state.isMobile ? "157px" : "0px",
                  }}
                >
                  Expert-Led. AI-Powered. Integrated E&S Intelligence.
                </h1>

                <p
                  style={{
                    fontSize: "18px",
                    lineHeight: "1.7",
                    marginBottom: "25px",
                  }}
                >
                  We bridge the gap between deep environmental expertise and
                  cutting-edge engineering. E&S Solutions provides a
                  comprehensive technology ecosystem designed for the full
                  project lifecycle — empowering developers, practitioners, and
                  corporations to move from static data to active trust.
                </p>

                <div style={{ marginBottom: "30px", fontSize: "16px" }}>
                  <div style={{ marginBottom: "8px" }}>
                    ✔ <strong>Development & Management:</strong> Digital audit
                    trails & grievance oversight
                  </div>
                  <div style={{ marginBottom: "8px" }}>
                    ✔ <strong>Impact Assessment:</strong> Accelerated ESDD &
                    ESIA workflows
                  </div>
                  <div>
                    ✔ <strong>ESG Disclosure:</strong> Verified stakeholder
                    dialogue
                  </div>
                </div>

                <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                  <Link
                    to="/plateform"
                    style={{
                      background: "#28a745",
                      color: "#fff",
                      padding: "12px 26px",
                      borderRadius: "6px",
                      textDecoration: "none",
                      fontWeight: "600",
                    }}
                  >
                    Explore Product Suite
                  </Link>

                  <a
                    href="mailto:info@essolutions.ai?subject=Demo&body=Hello,%20I’m%20interested%20to%20hear%20more%20about%20your%20products%20please%20get%20in%20touch."
                    style={{
                      border: "2px solid #28a745",
                      color: "#28a745",
                      padding: "12px 26px",
                      borderRadius: "6px",
                      textDecoration: "none",
                      fontWeight: "600",
                    }}
                  >
                    Book a Live Demo
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div
            style={{
              padding: this.state.isMobile
                ? "186px 20px 0px 20px"
                : "80px 20px",
              background: "#ffffff",
            }}
          >
            <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
              <h2
                style={{
                  fontSize: "32px",
                  fontWeight: "700",
                  marginBottom: "40px",
                }}
              >
                The Full E&S Lifecycle
              </h2>

              <div style={{ display: "flex", flexWrap: "wrap", gap: "40px" }}>
                <div style={{ flex: "1 1 300px" }}>
                  <h4>Development & Management</h4>
                  <p>
                    Streamlining operational E&S oversight and grievance
                    management with digital audit trails.
                  </p>
                </div>

                <div style={{ flex: "1 1 300px" }}>
                  <h4>Impact Assessment</h4>
                  <p>
                    Using our E&S research agent and automated benchmarking to
                    accelerate ESDD and ESIA workflows.
                  </p>
                </div>

                <div style={{ flex: "1 1 300px" }}>
                  <h4>ESG Disclosure</h4>
                  <p>
                    Turning complex data into interactive, verified dialogues
                    for stakeholders and investors.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div
            style={{
              padding: "120px 20px",
              background: "linear-gradient(180deg, #f7fafc 0%, #ffffff 100%)",
            }}
          >
            <div style={{ maxWidth: "1300px", margin: "0 auto" }}>
              <div style={{ textAlign: "center", marginBottom: "80px" }}>
                <h2
                  style={{
                    fontSize: "42px",
                    fontWeight: "700",
                    color: "#1f2933",
                    marginBottom: "15px",
                  }}
                >
                  Our Three Pillars of Innovation
                </h2>
                <p
                  style={{
                    fontSize: "18px",
                    color: "#6b7280",
                    maxWidth: "700px",
                    margin: "0 auto",
                  }}
                >
                  Intelligent systems for transparency, operational efficiency,
                  and enterprise-scale E&S engineering.
                </p>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
                  gap: "40px",
                }}
              >
                {/* Pillar Card Template */}
                {[
                  {
                    badge: "I",
                    title: "For Transparency",
                    subtitle: "Reporting & Stakeholder Engagement",
                    color: "#16a34a",
                    content: [
                      "DiscloseAI: An interactive Sustainability Disclosures Agent trained on your sustainability documents.",
                      "Verified Answers: Provides factual responses citing specific pages and paragraphs for total verification, eliminating hallucinations.",
                      "Universal Accessibility: Multilingual and voice command capabilities ensure inclusive engagement.",
                      "STAR Platform: AI-powered sustainability tracking, analysis and reporting (In Development).",
                    ],
                  },
                  {
                    badge: "II",
                    title: "For E&S Experts",
                    subtitle: "Operational Tech Stack & Research Lab",
                    color: "#2563eb",
                    content: [
                      "Operational Control: myESRA and privatESRA AI-powered E&S research agents with access to verified data used for ESIAs, ESDDs and monitoring.",
                      "The Research Lab: reviewESRA (benchmarking, ESAP compliance and ESDD) and SmartESIA (build you an 80% ready ESIA document).",
                      "The '80% Ready' Workflow: Draft documents with suggested impacts, mitigation measures and primary data collection suggestions.",
                    ],
                  },
                  {
                    badge: "III",
                    title: "For the Enterprise",
                    subtitle: "Bespoke E&S Engineering",
                    color: "#7c3aed",
                    content: [
                      "Deep Learning Capabilities: ML sentiment analysis identifying emerging social risks before escalation.",
                      "Strategic Scenario Modelling: Long-term modelling including 25-year SEA 2050 scenario work in Sierra Leone.",
                      "Custom Corporate Builds: Proprietary AI engines and dashboards tailored to your organizational framework.",
                      "AI agents speeding up the national permitting process.",
                    ],
                  },
                ].map((pillar, index) => (
                  <div
                    key={index}
                    style={{
                      background: "#ffffff",
                      padding: "40px",
                      borderRadius: "20px",
                      border: "1px solid #e5e7eb",
                      boxShadow: "0 20px 50px rgba(0,0,0,0.05)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "translateY(-6px)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "translateY(0px)")
                    }
                  >
                    {/* Badge */}
                    <div
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "12px",
                        background: pillar.color,
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "600",
                        marginBottom: "20px",
                      }}
                    >
                      {pillar.badge}
                    </div>

                    <h3
                      style={{
                        fontSize: "24px",
                        fontWeight: "700",
                        marginBottom: "6px",
                        color: "#111827",
                      }}
                    >
                      {pillar.title}
                    </h3>

                    <p
                      style={{
                        fontSize: "15px",
                        fontWeight: "500",
                        color: "#6b7280",
                        marginBottom: "25px",
                      }}
                    >
                      {pillar.subtitle}
                    </p>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "16px",
                      }}
                    >
                      {pillar.content.map((item, i) => (
                        <div key={i} style={{ display: "flex", gap: "12px" }}>
                          <CheckCircle
                            size={18}
                            style={{ color: pillar.color, marginTop: "4px" }}
                          />
                          <p
                            style={{
                              margin: 0,
                              fontSize: "15px",
                              lineHeight: "1.7",
                            }}
                          >
                            {item}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div style={{ padding: "80px 20px", background: "#ffffff" }}>
            <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
              <h2
                style={{
                  fontSize: "32px",
                  fontWeight: "700",
                  marginBottom: "30px",
                }}
              >
                Why E&S Solutions?
              </h2>

              <ul style={{ fontSize: "16px", lineHeight: "1.8" }}>
                <li>
                  <strong>Developed by E&S Experts:</strong> Built by industry
                  insiders.
                </li>
                <li>
                  <strong>Assurance-Ready Audit Trails:</strong> Full traceable
                  record of engagement.
                </li>
                <li>
                  <strong>Full Customization:</strong> Adapted to your brand and
                  framework.
                </li>
              </ul>
            </div>
          </div>
          <div className="newsletter">
            <div className="newsletter-container">
              <h1>Subscribe to our Newsletter</h1>
              <Link to="/newsletter" className="newsletter-container-button">
                Subscribe
              </Link>
            </div>
          </div>
          <Footer />
        </div>

        {/* <div className='newsletter'>
                    <div className='newsletter-container'>
                        <h1>Subscribe for updates</h1>
                        <Link to="/newsletter" className="newsletter-container-button">Stay Informed</Link>
                    </div>
                </div> */}
      </>
    );
  }
}

export default withRouter(NewLanding);
